module.exports = __webpack_public_path__ + "img/Truck.3b2d076f.png";